export default class Cancellable {
    private _cancel: boolean = false;

    public get hasCancelled() { return this._cancel; }
    public cancel = () => { this._cancel = true; }
}